import { Doughnut, mixins } from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ['options'],
  watch: {
    options: {
      handler() {
        const chart = this.$data._chart
        chart.options = this.options
        chart.update()
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
